import { noop } from 'lodash';

import { UseUpdateOnAppStateChange } from './types';

export const useUpdateOnAppStateChange: UseUpdateOnAppStateChange = noop;
